import { setUser } from '@sentry/react'
import { useUser, useSessionContext } from '@supabase/auth-helpers-react'
import { Loader } from '@mantine/core'
import { useEffect } from 'react'
import useRybbit from '../../hooks/useRybbit'
import LoginPage from '@/pages/login'
import useMe from '@/hooks/useMe'

function SentryUserContext({ userId }) {
    const { id, name } = useMe()
    // SWR may still hold another account's profile after a session switch.
    const username = id === userId ? name : undefined

    useEffect(() => {
        setUser({ id: userId, ...(username ? { username } : {}) })
        return () => setUser(null)
    }, [userId, username])

    return null
}

function LoadingScreen() {
    return (
        <div className="flex items-center justify-center min-h-screen">
            <Loader type="bars" size="sm" />
        </div>
    )
}

export default function AuthGuard({ children }) {
    const { isLoading } = useSessionContext()
    const user = useUser()

    useRybbit()

    useEffect(() => {
        if (user) {
            localStorage.setItem(
                'last_user',
                JSON.stringify({
                    id: user.id,
                    email: user.email,
                })
            )
        }
    }, [user])

    if (isLoading) return null

    if (!user) return <LoginPage />

    return (
        <>
            <SentryUserContext userId={user.id} />
            {children}
        </>
    )
}
